// extracted by mini-css-extract-plugin
module.exports = {"pg-my-profile":"styles_pg-my-profile__1QETo","cp-my-profile":"styles_cp-my-profile__c3544","cp-my-profile-extra":"styles_cp-my-profile-extra__1btYa"};